const w = window

import jQuery from 'jquery'
import 'jquery.easing'
import 'bootstrap'
import 'slick-carousel'
import 'bootstrap-datepicker';
import '../../node_modules/bootstrap-datepicker/dist/locales/bootstrap-datepicker.ja.min.js';
import './plugins/pagescroll.js'
import './plugins/scrollevent.js'
import './plugins/loadhtml.js'
// import './plugins/googlemap.js'
import CURRENT_NAV from './plugins/currentNav.js';

const $ = w.jQuery = jQuery;
w.load = {
  'init': new $.Deferred
}
import './plugins/layerednav';
import './plugins/footNav';

import './page/home';
import './page/aboutus';

// Google Tag manager
((w,d,s,l,i)=>{w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(w,document,'script','dataLayer','GTM-NK9592B');

document.documentElement.classList.remove('no-js')

CURRENT_NAV()

$(()=>{

  // Start layerdnav
  $('[data-plugin=layerednav]').layerednav({
    classes:['is-depth-0','is-depth-1','is-depth-2']
  });

  // toggle g-navi
  $('[data-plugin=toggleNav]').on('click',function(){
    const target = this.dataset.target
    if(target == undefined ) console.info('undefined "data-target" from toggleNav') // eslint-disable-line no-console
    if( $(target).hasClass('open') ){
      $(target).addClass('closing')
      setTimeout(()=> $(target).removeClass('closing') ,500)
    }
    $(target).toggleClass('open')
    $(this).toggleClass('active')
    $('body').toggleClass('navOpen')
  });


  w.load['loadhtml'] = $('[data-load-html]').loadhtml()

  // フッターナビ用(SPのみ)
  $('[data-plugin=collapseNav]').collapseNav()

  // 園歌再生
  $('[data-plugin=playsong]').each((i,self)=>{
    const opt = $.extend(true,{},self.dataset),
          audio = new Audio()
    let is_play = false
    audio.src = opt.src
    audio.load()
    audio.addEventListener('ended', () => is_play = false)
    $(self).on('click',()=>{
      if( is_play == false){
        audio.play()
        is_play = true
      }else{
        audio.pause()
        audio.currentTime = 0;
        is_play = false
      }
    })
  })

  /****************************
 * 郵便番号検索ボタン
 */
  $('[data-plugin=ajaxzip]').on('click',()=>{
    AjaxZip3.zip2addr('zip','','addr','addr'); // eslint-disable-line no-undef
    return false;
  });

  w.load.init.resolve()
});

$(w).on('load',()=>{
  $('body').removeClass('loading')
})
